import React, {useEffect} from 'react';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export default function MultiAutoComplete({ field = {}, values = {}, onChange = () => { }, ...props }) {
  let _value = props.fieldValues[field.key] || values[field.key];

  let defaultValue = field.options.filter(x => (field.value || _value || []).includes(x.value));

  useEffect(() => {
    if(!field.show) {
      onChange(field, null);
    }
  }, [field.show]);

  return (
    <Autocomplete
      multiple
      
      id="checkboxes-autocomplete"
      disableCloseOnSelect
      options={field.options}
      onChange={(e, val = []) => {
          onChange(field, val.map(x => x.value));
      }}
      defaultValue={defaultValue}
      limitTags={2}
      getOptionLabel={option => option.label}
      disabled={field.disabled}
      style={{display: field.show? 'block': 'none'}}
      renderTags={(value, getTagProps) =>
          value.map((option, index) => {
              const { key, ...tp } = getTagProps({ index });
              return (
                <Chip key={key}
              variant="outlined"
              label={option.label}
              
              {...tp}
            />
              );
            })
      }
      renderInput={params => (
        <TextField {...params}  variant="outlined" label={field.label} placeholder={field.label} />
      )}
    />
  );
}